<script>
import Loading from '../../components/loading.vue';
import Refund from '../../components/mineTable/refund.vue';
import RefundPopup from '../../components/mineTable/refundPopup.vue';

export default {
    name: "refund",
    data() {
        return {
            list: [],
            isLoading: false,
            // page: 1,
            // totalPage: 1,
            isShowPopup: false,
            logisticsId: null,
        };
    },
    computed: {},
    components: {
        Loading,
        Refund,
        RefundPopup
    },
    mounted() {
        this.getRefundList();
    },
    destroyed() {},
    watch: {},
    methods: {
        // 获取退款订单列表
        getRefundList() {
            this.isLoading = true;
            this.$store.dispatch('getRefundList', {
                // page: this.page,
                // limit: 10,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    // this.totalPage = result.data.last_page;
                    // this.list = this.list.concat(result.data.list);
                    this.list = result.data;
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        // 加载更多退款订单
        // loadMore() {
        //     if (this.page < this.totalPage) {
        //         this.page++;
        //         this.getRefundList();
        //     }
        // },
        // 填写物流信息
        fillLogistics(id) {
            this.isShowPopup = true;
            this.logisticsId = id;
        },
        // 提交物流信息
        submitLogistics(data) { 
            this.$store.dispatch('fillRefundLogistics', {
                id: this.logisticsId,
                logistics_number: data.code,
                logistics_company: data.name,
            }).then((result) => {
                if (result.code == 100) { 
                    this.$showToast({ text: '提交成功' });
                    this.isShowPopup = false;
                    this.getRefundList();
                } else {
                    this.$showToast({ text: result.msg || '提交失败，请稍后重试' });
                }
            }).catch((err) => {
                this.$showToast({ text: '提交失败，请稍后重试' });
            });
        },
        // 撤销申请
        revokeApplication(id, isMobile = false) {
            // 是否确认撤销
            if (isMobile) { 
                this.$showModal({
                    text: '是否确认撤销退款申请？',
                    onHide: (type) => {
                        if (type === 'confirm') {
                            this.confirmRevokeApplication(id);
                        }
                    },
                });
            } else {
                if (confirm('是否确认撤销退款申请？')) { 
                    // this.list.splice(index, 1);
                    this.confirmRevokeApplication(id);
                }
            }
        },
        // 确认撤销
        confirmRevokeApplication(id) {
            this.$store.dispatch('revokeRefundApplication', {
                id: id,
            }).then((result) => {
                if (result.code == 100) { 
                    this.$showToast({ text: '撤销成功' });
                    this.getRefundList();
                } else {
                    this.$showToast({ text: result.msg || '撤销失败，请稍后重试' });
                }
            }).catch((err) => {
                this.$showToast({ text: '撤销失败，请稍后重试' });
            });
        },
    },
};
</script>

<template>
    <div class="refund">
        <p class="title">退款管理</p>
        <div class="loading_wrap" v-if="isLoading">
            <Loading/>
        </div>
        <p class="no_more" v-else-if="list.length == 0">你还没有退款订单</p>
        <Refund v-else :data="list" @fill-logistics="fillLogistics" @revoke-application="revokeApplication" />
        <!-- <div class="loading_wrap" v-if="isLoading">
            <Loading/>
        </div>
        <div class="flex justify_center" v-else-if="page < totalPage">
            <p class="load_more" @click="loadMore">查看更多</p>
        </div> -->
        <RefundPopup :show="isShowPopup" @close="isShowPopup = false" @submit-logistics="submitLogistics" />
    </div>
</template>

<style scoped lang="scss">
.refund{
    
}
</style>